import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import Select from 'react-select';

import { ManufacturerGlnSourceOptions } from 'lib/enums/ManufacturerGlnSource';

function GLNSourceEditor({ value, onChange }) {
  const [selectedOption, setSelectedOption] = useState(value);
  return (
    <div className={css(styles.container)}>
      <Select
        isClearable
        autoFocus
        options={ManufacturerGlnSourceOptions}
        value={ManufacturerGlnSourceOptions.find(opt => opt.value === selectedOption) || null}
        placeholder="None (Default)"
        onChange={option => {
          setSelectedOption(option?.value || null);
          onChange(option?.value || null);
        }}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    minWidth: '400px',
  },
});

GLNSourceEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default GLNSourceEditor;
